module.exports = __webpack_public_path__ + "static/media/logo-ies-azul.dd3c9e42.svg";